import React, { PropsWithChildren, useEffect } from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { StripeElementsOptions } from '@stripe/stripe-js';

import {
  usePaymentStore,
  paymentStoreSelector,
} from '../../stores/paymentStore';

import useElementsAppearance from './hooks/useElementsAppearance';
import { PaymentProviderProps } from './types';

const PaymentProvider: React.FC<PropsWithChildren<PaymentProviderProps>> = ({
  children,
  mode,
  amount,
  currency,
  captureMethod,
}) => {
  const appearance = useElementsAppearance();
  const stripe = usePaymentStore(paymentStoreSelector.stripe);
  const paymentActions = usePaymentStore(paymentStoreSelector.actions);

  const options: StripeElementsOptions = {
    fonts: [
      {
        family: 'Inter',
        src: `url(https://static.kittl.com/Inter-roman.var.woff2?v=3.15)`,
      },
    ],
    appearance,
    loader: 'never',
    mode,
    setupFutureUsage: 'off_session',
    amount,
    currency,
    captureMethod,
  };

  useEffect(() => {
    if (!stripe) {
      paymentActions.init();
    }
  }, [paymentActions, stripe]);

  return (
    <Elements options={options} stripe={stripe}>
      {children}
    </Elements>
  );
};

export default PaymentProvider;
